export class ItemDisponibModel {

    fasciaOraria: string;
    data: string;
    numeroCoperti: string;
    idTipoPrenotazioneRistoranteConsentita: string;

    constructor() {
        this.fasciaOraria = "";
        this.data = "";
        this.numeroCoperti = "";
        this.idTipoPrenotazioneRistoranteConsentita = "";
    }

    reset() {
        this.fasciaOraria = "";
        this.data = "";
        this.numeroCoperti = "";
        this.idTipoPrenotazioneRistoranteConsentita = "";
    }
}